<template lang="pug">
b-modal#addOperator(
  ref="addOperator"
  :title="$t('ui.combine.add_account')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')").mb-0
      DebounceInput(
        size="sm"
        ref="account_id"
        required
        alphaNum
        type="text"
        :dirty="$v.account_id.$dirty"
        :error="$v.account_id.$error"
        v-model.trim.lazy="$v.account_id.$model"
        :disabled="loading"
        :maxLength="$v.account_id.$params.maxLength.max"
      )
      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
    b-form-group(:label="$t('ui.password')").mb-0
      DebounceInput(
        size="sm"
        required
        type="password"
        :dirty="$v.password.$dirty"
        :error="$v.password.$error"
        v-model.trim.lazy="$v.password.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.password" :name="$t('ui.password')")
    b-form-group(:label="$t('ui.confirm_password')").mb-0
      DebounceInput(
        size="sm"
        required
        type="password"
        :dirty="$v.confirm_password.$dirty"
        :error="$v.confirm_password.$error"
        v-model.trim.lazy="$v.confirm_password.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')", :name2="$t('ui.password')")
    b-form-group(:label="$t('ui.account_type')").mb-0
      b-form-select(
        size="sm"
        required
        :dirty="$v.account_type.$dirty"
        :error="$v.account_type.$error"
        v-model.trim.lazy="$v.account_type.$model"
        :disabled="loading"
      )
        option(value=3) {{ $t('ui.master') }}
      ValidateResult(:value="$v.account_type" :name="$t('ui.account_type')")
    b-form-group(:label="$t('ui.full_name')").mb-0
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.full_name.$dirty"
        :error="$v.full_name.$error"
        v-model.trim.lazy="$v.full_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
    b-form-group(:label="$t('ui.contact_phone')").mb-0
      DebounceInput(
        size="sm"
        numeric
        type="text"
        :dirty="$v.contact_phone.$dirty"
        :error="$v.contact_phone.$error"
        v-model.trim.lazy="$v.contact_phone.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
    b-form-group(:label="$t('ui.contact_email')").mb-0
      DebounceInput(
        size="sm"
        email
        type="text"
        :dirty="$v.contact_email.$dirty"
        :error="$v.contact_email.$error"
        v-model.trim.lazy="$v.contact_email.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      account_id: "",
      password: "",
      confirm_password: "",
      account_type: "",
      full_name: "",
      contact_phone: "",
      contact_email: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    accountType() {
      return this.$store.getters.accountType;
    }
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    password: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    },
    account_type: {
      required
    },
    full_name: {
      alphaNumWithSpace
    },
    contact_phone: {
      integer
    },
    contact_email: {
      email
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.accountAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.account_id,
          password: this.password,
          account_type: this.account_type,
          full_name: this.full_name,
          contact_phone: this.contact_phone,
          contact_email: this.contact_email,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.account_type);
                  this.$refs.addOperator.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_account", this.feedback.status);
                  this.$refs.addOperator.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.account_id = "";
      this.password = "";
      this.confirm_password = "";
      this.account_type = "";
      this.full_name = "";
      this.contact_phone = "";
      this.contact_email = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.account_id.$el.focus();
      this.account_type = this.accountType - 1;
    }
  }
};
</script>
